import dayjs from 'dayjs';
import { Query } from 'graphql/generated/graphqlTypes';
import {
  generateMockNfcCard,
  generateMockNfcCardAssignment,
  generateMockNfcCardAssignmentBlockedInfo
} from 'mocks/graphqlMocks/nfcCard';
import { generateMockVisitor } from 'mocks/graphqlMocks/visitor';

export function mockedGetAllVisitorsCardsWithoutNestedResolversData(
  getNfcCards: Query['getNfcCards']
): Pick<Query, 'getNfcCards'> {
  return { getNfcCards };
}

export const mockedGetAllVisitorsCardsWithoutNestedResolversDataForQuery =
  mockedGetAllVisitorsCardsWithoutNestedResolversData([
    generateMockNfcCard({ uuid: 'mockedNfcCardUuid1', name: 'Mock Card 1' }),
    generateMockNfcCard({ uuid: 'mockedNfcCardUuid2', name: 'Mock Card 2' }),
    generateMockNfcCard({
      uuid: 'mockedNfcCardUuid3',
      name: 'Mock Card 3',
      assignment: generateMockNfcCardAssignment({
        expiryDate: dayjs().add(1, 'day').toISOString(),
        visitor: generateMockVisitor({ id: 'mockVisitorId8', name: 'Mock Visitor 8' }),
        visitorName: 'Mock Visitor 8'
      })
    }),
    generateMockNfcCard({
      uuid: 'mockedNfcCardUuid4',
      name: 'Mock Card 4',
      assignment: generateMockNfcCardAssignment({
        expired: true,
        expiryDate: dayjs().subtract(1, 'day').toISOString(),
        visitor: generateMockVisitor({ id: 'mockVisitorId9', name: 'Mock Visitor 9' }),
        visitorName: 'Mock Visitor 9'
      })
    }),
    generateMockNfcCard({
      uuid: 'mockedNfcCardUuid5',
      name: 'Mock Card 5',
      assignment: generateMockNfcCardAssignment({
        blocked: generateMockNfcCardAssignmentBlockedInfo({ reason: 'Lost card' }),
        expiryDate: dayjs().add(1, 'year').toISOString(),
        visitor: generateMockVisitor({ id: 'mockVisitorId12', name: 'Mock Visitor 12' }),
        visitorName: 'Mock Visitor 12'
      })
    }),
    generateMockNfcCard({
      uuid: 'mockedNfcCardUuid6',
      name: 'Mock Card 6',
      assignment: generateMockNfcCardAssignment({
        expiryDate: dayjs().add(1, 'week').toISOString(),
        visitor: generateMockVisitor({ id: 'mockVisitorId11', name: 'Mock Visitor 11' }),
        visitorName: 'Mock Visitor 11'
      })
    })
  ]);
